import React from 'react';

import {
  Col,
  Row,
} from 'nexcomponent-ui';
import { useSelector } from 'react-redux';

import { searchFormData } from '../../../../../Utils/Form';
import style from '../FieldSearch/Field.module.css';
import FieldSearch from '../FieldSearch/FieldSearch';

function FieldProductKeyAccountSearchForm(props) {
  const {t} = props;
  const searchData = useSelector(state => state.utils.searchData);
  const formValidation = useSelector(state => state.utils.formValidation);
  const formData = e => {
    searchFormData(e, searchData, props.dispatch);
  };
  return (
    <Row>
      <Col className={style.Col} size="lg" width={6}>
        <FieldSearch
          className={style.InputLeft}
          label={t("COMMON:FIELD.PRODUCT_KEY_ACCOUNT_ID")}
          type={"number"}
          name="product_key_account_id"
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRODUCT_KEY_ACCOUNT_ID")})}
          onChange={formData}
        />
        <FieldSearch
          className={style.InputLeft}
          label={t("COMMON:FIELD.PRINCIPAL_CODE")}
          type={"text"}
          name={"principal_code"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_CODE")})}
          onChange={formData}
          valid={formValidation.principal_code}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"text"}
          name={"principal_name"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_NAME")})}
          onChange={formData}
          label={t("COMMON:FIELD.PRINCIPAL_NAME")}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"number"}
          name={"principal_id"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_ID")})}
          onChange={formData}
          label={t("COMMON:FIELD.PRINCIPAL_ID")}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"text"}
          name={"code"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.CODE")})}
          onChange={formData}
          label={t("COMMON:FIELD.CODE")}
        />
      </Col>
      <Col className={style.Col} size="lg" width={6}>
        <FieldSearch
          className={style.InputRight}
          name={"name"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.NAME")})}
          onChange={formData}
          label={t("COMMON:FIELD.NAME")}
        />
        <FieldSearch
          className={style.InputRight}
          type={"text"}
          name={"level"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.LEVEL")})}
          onChange={formData}
          label={t("COMMON:FIELD.LEVEL")}
        />
        <FieldSearch
          className={style.InputRight}
          label={t("COMMON:FIELD.PARENT_CODE")}
          type={"text"}
          name={"parent_code"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PARENT_CODE")})}
          onChange={formData}
        />
        <FieldSearch
          className={style.InputRight}
          type={"text"}
          name={"parent_name"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PARENT_NAME")})}
          onChange={formData}
          label={t("COMMON:FIELD.PARENT_NAME")}
        />
        <FieldSearch
          className={style.InputRight}
          type={"number"}
          name={"parent_id"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PARENT_ID")})}
          onChange={formData}
          label={t("COMMON:FIELD.PARENT_ID")}
        />
      </Col>
    </Row>
  );
}

export default FieldProductKeyAccountSearchForm;
